import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RemoveAuthHeaderInterceptor } from './interceptors';

@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useExisting: RemoveAuthHeaderInterceptor,
      multi: true,
    },
  ],
})
export class RemoveAuthHeaderModule {}
